module.exports = __webpack_public_path__ + "static/img/act_text_01.b312240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/act_text_01.png
// module id = oKfv
// module chunks = 1